import React, { PureComponent } from 'react';
import T from 'prop-types';
import { markerPropType } from '../../../customPropTypes';

const PLACEHOLDER_AUDIO = '/assets/audio/ad_prebump.mp3';
const MAIN_AUDIO_ID = 'editor-main-audio';
const AD_JINGLE_AUDIO_ID = 'editor-ad-placeholder-audio';

class AudioContainer extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      paused: true,
      currentTime: 0,
    };
  }

  componentDidMount() {
    this.adJingleAudio.addEventListener('ended', this.handleAdJingleAudioEndedEvent);
    this.mainAudio.addEventListener('timeupdate', this.handleMainAudioTimeUpdateEvent);
    this.mainAudio.addEventListener('ended', this.handleMainAudioEndedEvent);
  }

  componentWillUnmount() {
    this.adJingleAudio.removeEventListener('ended', this.handleAdJingleAudioEndedEvent);
    this.mainAudio.removeEventListener('timeupdate', this.handleMainAudioTimeUpdateEvent);
    this.mainAudio.removeEventListener('ended', this.handleMainAudioEndedEvent);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.src !== this.props.src) {
      this.mainAudio.src = this.props.src;
    }
  }

  playAdJingleIfAdMarkerAtBeginning() {
    const hasAdMarkerAtBeginning = Boolean(
      this.props.adMarkers.find(adMarker => adMarker.start === 0)
    );
    this.currentAudio = hasAdMarkerAtBeginning ? this.adJingleAudio : this.mainAudio;
  }

  maybePlayAdJingle(previousMainAudioProgress, nextMainAudioProgress) {
    const hasAdMarkerInBetween = this.props.adMarkers.some(
      adMarker =>
        adMarker.start > previousMainAudioProgress && adMarker.start < nextMainAudioProgress
    );

    if (hasAdMarkerInBetween) {
      this.mainAudio.pause();
      this.adJingleAudio.play();
      this.currentAudio = this.adJingleAudio;
      this.setState({ paused: false });
    }
  }

  handleMainAudioTimeUpdateEvent = event => {
    const { currentTime } = event.target;
    if (!this.state.paused) {
      this.maybePlayAdJingle(this.state.currentTime, currentTime);
    }
    this.setState({ currentTime });
  };

  handleAdJingleAudioEndedEvent = () => {
    if (this.state.ended) {
      this.setState({ paused: true });
    } else {
      this.mainAudio.play();
    }

    this.currentAudio = this.mainAudio;
  };

  handleMainAudioEndedEvent = () => {
    this.setState({
      ended: true,
      paused: this.adJingleAudio.paused,
    });
  };

  play = () => {
    const { currentTime, ended } = this.state;
    if (currentTime === 0 || ended) {
      this.playAdJingleIfAdMarkerAtBeginning();
    }

    this.currentAudio.play();
    this.setState({
      paused: false,
      ended: false,
      currentTime: ended ? 0 : currentTime,
    });
  };

  pause = () => {
    this.currentAudio.pause();
    this.setState({ paused: true });
  };

  seek = seconds => {
    this.mainAudio.currentTime = seconds;
    this.currentAudio = this.mainAudio;
    this.setState({ currentTime: seconds });
  };

  setMainAudio = element => {
    if (element && element !== this.mainAudio) {
      this.mainAudio = element;
    }
  };

  setAdJingleAudio = element => {
    if (element && element !== this.adJingleAudio) {
      this.adJingleAudio = element;
    }
  };

  render() {
    return (
      <>
        <audio ref={this.setMainAudio} id={MAIN_AUDIO_ID} src={this.props.src} />
        <audio ref={this.setAdJingleAudio} id={AD_JINGLE_AUDIO_ID} src={PLACEHOLDER_AUDIO} />
        {this.props.children({
          src: this.props.src,
          paused: this.state.paused,
          currentTime: this.state.currentTime,
          play: this.play,
          pause: this.pause,
          seek: this.seek,
          isPlayingAdJingle: this.currentAudio === this.adJingleAudio,
        })}
      </>
    );
  }
}

AudioContainer.propTypes = {
  children: T.func.isRequired,
  adMarkers: T.arrayOf(markerPropType),
  src: T.string,
};

export default AudioContainer;
